/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'log-cinematic-selection-bar';
const prefix = `${moduleName}.${componentName}`;

export const previousLogLabel = `${prefix}.previousLogLabel`;
export const nextLogLabel = `${prefix}.nextLogLabel`;

export const ENGLISH = {
    [previousLogLabel]: 'Previous Log',
    [nextLogLabel]: 'Next Log',
};
